/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationData } from './PaginationData';
import {
    PaginationDataFromJSON,
    PaginationDataFromJSONTyped,
    PaginationDataToJSON,
    PaginationDataToJSONTyped,
} from './PaginationData';
import type { SchedulerSessionOverviewData } from './SchedulerSessionOverviewData';
import {
    SchedulerSessionOverviewDataFromJSON,
    SchedulerSessionOverviewDataFromJSONTyped,
    SchedulerSessionOverviewDataToJSON,
    SchedulerSessionOverviewDataToJSONTyped,
} from './SchedulerSessionOverviewData';

/**
 * 
 * @export
 * @interface SchedulerSessions200Response
 */
export interface SchedulerSessions200Response {
    /**
     * 
     * @type {PaginationData}
     * @memberof SchedulerSessions200Response
     */
    pagination?: PaginationData;
    /**
     * 
     * @type {Array<SchedulerSessionOverviewData>}
     * @memberof SchedulerSessions200Response
     */
    data?: Array<SchedulerSessionOverviewData>;
}

/**
 * Check if a given object implements the SchedulerSessions200Response interface.
 */
export function instanceOfSchedulerSessions200Response(value: object): value is SchedulerSessions200Response {
    return true;
}

export function SchedulerSessions200ResponseFromJSON(json: any): SchedulerSessions200Response {
    return SchedulerSessions200ResponseFromJSONTyped(json, false);
}

export function SchedulerSessions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchedulerSessions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': json['pagination'] == null ? undefined : PaginationDataFromJSON(json['pagination']),
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(SchedulerSessionOverviewDataFromJSON)),
    };
}

export function SchedulerSessions200ResponseToJSON(json: any): SchedulerSessions200Response {
    return SchedulerSessions200ResponseToJSONTyped(json, false);
}

export function SchedulerSessions200ResponseToJSONTyped(value?: SchedulerSessions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDataToJSON(value['pagination']),
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(SchedulerSessionOverviewDataToJSON)),
    };
}

